import { Reducer } from 'redux';
import {
  OPEN_INDIVIDUAL_ABSENCE_NOTE_DRAWER,
  CLOSE_INDIVIDUAL_ABSENCE_NOTE_DRAWER,
  IndividualAbsenceNoteDrawerActions,
} from '../actions/individualAbsenceNoteDrawer';
import { CLEAR_PRIO_CACHE } from '../../../actions';

export interface IndividualAbsenceNoteDrawerState {
  open: boolean;
}

const initialState: IndividualAbsenceNoteDrawerState = {
  open: false,
};

const reducer: Reducer<
  IndividualAbsenceNoteDrawerState,
  IndividualAbsenceNoteDrawerActions
> = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_INDIVIDUAL_ABSENCE_NOTE_DRAWER: {
      return { ...state, open: true };
    }
    case CLOSE_INDIVIDUAL_ABSENCE_NOTE_DRAWER: {
      return { ...state, open: false };
    }
    case CLEAR_PRIO_CACHE: {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;

export const getOpen = (state: IndividualAbsenceNoteDrawerState) => state.open;
